import React, { FC } from 'react';
import { Typography } from '@mui/material';
import { Skeleton } from '@mui/material';
import useStyles from './styles';
import { ITitle } from './types';

const Title: FC<ITitle> = props => {
  const { title } = props;
  const classes = useStyles();

  return (
    <Typography variant="h1" className={classes.title}>
      {title || <Skeleton />}
    </Typography>
  );
};

export default Title;
